import { rabbitHttp } from './http';
import { isApiError, BasketApiErrorModel } from 'models/Errors';
import { errorToBasketErrorModel } from 'helpers';

const BASKET_CREATED_EXCHANGE = 'Basket.Created';

export class RabbitRepository {
    public async basketCreated(basketId: string, username: string): Promise<void> {
        try {
            const url = '/';

            await rabbitHttp.post(url,
                {
                    // additional JSON stringfy - cloned from old code
                    messageBody: JSON.stringify({ uid: username, guid: basketId }),
                    exchange: BASKET_CREATED_EXCHANGE
                }
            );
        } catch (error) {
            const errorSource = 'rabbit.repository:basketCreated';
            if (isApiError(error)) {
                throw new BasketApiErrorModel(error, errorSource);
            } else {
                throw errorToBasketErrorModel(error, errorSource);
            }
        }
    }
}

export const rabbit = new RabbitRepository();